import { ZOHO_AUTH_SCOPES, ZOHO_BOOKS_SCOPES, ZOHO_CRM_SCOPES } from "./scope";

export const apiUrlMap = {
  US: "https://www.zohoapis.com",
  EU: "https://www.zohoapis.eu",
  AU: "https://www.zohoapis.com.au",
  IN: "https://www.zohoapis.in",
  JP: "https://www.zohoapis.jp",
  SA: "https://www.zohoapis.sa",
  CA: "https://www.zohocloud.ca",
};

export const accountUrlMap = {
  US: "https://accounts.zoho.com",
  AU: "https://accounts.zoho.com.au",
  EU: "https://accounts.zoho.eu",
  IN: "https://accounts.zoho.in",
  JP: "https://accounts.zoho.jp",
  SA: "https://accounts.zoho.sa",
  CA: "https://accounts.zohocloud.ca",
};

export const clientIdMap = {
  US: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  AU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  EU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  IN: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  JP: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  SA: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  CA: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
};

export const clientSecretMap = {
  US: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  AU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  EU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  IN: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  JP: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  SA: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  CA: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
};

export const getAllServiceList = (dataCenter = "US") => {
  return [
    {
      name: "ZOHO AUTH",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__zoho",
      authorizeUrl: accountUrlMap[dataCenter] + "/oauth/v2/auth",
      clientId: clientIdMap[dataCenter],
      clientSecret: clientSecretMap[dataCenter],
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      refreshTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      accessTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      revokeUrl: accountUrlMap[dataCenter] + `/oauth/v2/token/revoke`,
      scopes: ZOHO_AUTH_SCOPES,
      scopeSeperator: ",",
    },
  ];
};

// orgId__REACT_APP_EXTENSION_IDENTIFIER__zohoauth__zoho_crm_conn__email@
